var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_c('button',{staticClass:"dropdown-button btn-transparent",on:{"click":_vm.show}},[_c('i',{staticClass:"icon more"})]),_vm._v(" "),(_vm.isActive)?_c('div',{staticClass:"dropdown-list"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }